module.exports = __webpack_public_path__ + "static/media/Tooltip-white.32e88c07.svg";